/* Правила https://app.zeplin.io/project/5af9b0d6a237e9933b4a6d0a/screen/61f009b6ce3e4ba2e1d6e0b3 */

import { CAT_IDS_BY_TYPES, CAT_TYPES } from '../constants';
import { mergeMovingTypes } from './combineMovingTypes';

const MAX_TAGS = 4;

const getIndexOfInterest = (interestId: number) => {
  return CAT_IDS_BY_TYPES[CAT_TYPES.INTEREST].indexOf(interestId);
};

const interestsSort = (a: { id: number }, b: { id: number }) => {
  return getIndexOfInterest(a.id) - getIndexOfInterest(b.id);
};

const mapToNames = (items: { name: string }[]) => {
  return items.map(({ name }) => name);
};

const prepareTags = (categories?: { id: number; name: string }[]) => {
  if (!categories) {
    return [];
  }

  const tags: string[] = [];
  let tagsCount = 0; // длина массива не подходит из-за тэгов с объединениями

  const tagsByTypes = Object.keys(CAT_TYPES).reduce<{
    [key: string]: { id: number; name: string }[];
  }>((acc, catType) => {
    return {
      ...acc,
      [catType]: [],
    };
  }, {});

  categories.forEach((category) => {
    for (const catType in CAT_IDS_BY_TYPES) {
      const typeIds = CAT_IDS_BY_TYPES[catType];

      if (typeIds.includes(category.id)) {
        tagsByTypes[catType].push(category);
      }
    }
  });

  const {
    [CAT_TYPES.CATEGORY]: categoryTags,
    [CAT_TYPES.MOVING_TYPE]: movingTypeTags,
    [CAT_TYPES.INTEREST]: interestTags,
  } = tagsByTypes;

  if (categoryTags.length) {
    tags.push(categoryTags[0].name);
    tagsCount++;
  }

  if (movingTypeTags.length && movingTypeTags.length <= MAX_TAGS - tagsCount) {
    tags.push(mergeMovingTypes(mapToNames(movingTypeTags)));
    tagsCount += movingTypeTags.length;
  }

  if (interestTags.length && MAX_TAGS - tagsCount > 0) {
    const interestTagsToAdd = interestTags.slice(0, MAX_TAGS - tagsCount);
    const sortedInterests = interestTagsToAdd.sort(interestsSort);

    tags.push(...mapToNames(sortedInterests));
  }

  // если совсем ничего не удалось извлечь
  // то берём хоть что-то
  if (!tags.length && categories.length) {
    tags.push(...mapToNames(categories.slice(0, 1)));
  }

  return tags;
};

export default prepareTags;
